export class ParsedError {
  public header: string;

  public response: {
    custom?: string;
    exception?: string;
    id?: string;
    hint?: string;
    message?: string;
    resultCode?: string;
    violatingFields?: {
      allowedValue: string;
      name: string;
      value: string;
    }[];
  };

  public text?: string;

  constructor({ header, response, text }: ParsedError) {
    this.header = header;
    this.response = response;
    this.text = text;
  }
}
